
import Vue from 'vue';
import { autoTranslate } from '@/helpers/autoTranslate';

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} },
    rowDisabled: { type: Boolean, default: false }
  },
  computed:{
    autoTranslatedLabel: function(): string {
      return autoTranslate(this.input.label);
    }
  }
})
